<template>
  <div id="catalogSearchProducts" class="searchProducts">
    <div v-if="!topPage" class="fixed bottom-4 right-4 cursor-pointer hidden md:block" @click.prevent="scrollToTop">
      <ArrowUpCircleIcon
        class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor-pointer"
        aria-hidden="true"
      />
    </div>
    <transition-group
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 m-0 p-0 gap-4 list-none"
      tag="div"
      name="fade"
      mode="out-in"
    >
      <v-search-product
        v-for="searchProduct in searchProducts"
        :key="searchProduct.productId"
        :search-product="searchProduct"
        @favorite-added="loadSearch()"
      />
    </transition-group>
  </div>
</template>

<script>
import VSearchProduct from './SearchProduct';
import { ArrowUpCircleIcon } from '@heroicons/vue/20/solid';
import router from '@/router';

export default {
  name: 'VSearchProducts',
  components: {
    VSearchProduct,
    ArrowUpCircleIcon
  },
  props: {
    searchProducts: {
      type: Array,
      default: () => []
    },
    assortmentFlow: {
      type: Boolean,
      default: false
    },
    searchProductsTerm: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    if (props.searchProducts && props.searchProducts.length > 0) {
      let products = [];
      props.searchProducts.forEach((product) => {
        products.push({
          item_id: product.baseProductId,
          item_name: product.title,
          item_brand: product.manufName,
          quantity: 1
        });
      });
      window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_name: router.currentRoute.value.path,
          search_term: props.searchProductsTerm,
          items: products
        }
      });
    }
  },
  data() {
    return {
      bottom: false,
      topPage: false
    };
  },
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.$emit('loadMore');
      }
    }
  },
  created() {
    window.addEventListener('scroll', () => {
      this.bottom = this.bottomVisible();
      this.topPage = this.topVisible();
    });
  },
  methods: {
    topVisible() {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      return scrollY === 0;
    },
    bottomVisible() {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = Math.ceil(visible + scrollY) >= Math.ceil(pageHeight);
      return bottomOfPage;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    loadSearch() {
      this.$emit('reloadSearch');
    }
  }
};
</script>
